module.exports = __webpack_public_path__ + "img/icon-bucket.fc46ab24.svg";